import React, { useState } from 'react';
import MailIcon from '@moda/icons/mail-16';
import { EmailShareFragment, EmailShareVariantFragment } from '../../generated/types';
import { EmailProductShareModal } from '../EmailShare';
import { ShareLink } from './ShareLink';

interface Props {
  variant: EmailShareFragment;
  activeVariant: EmailShareVariantFragment;
}

export const EmailShareLink: React.FC<Props> = ({ variant, activeVariant }) => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <EmailProductShareModal
        activeVariant={activeVariant}
        variant={variant}
        onClose={() => setModalVisible(false)}
        show={modalVisible}
      />

      <ShareLink
        aria-label="Share with email"
        handleClick={() => setModalVisible(true)}
        data-testid="email-share-link"
      >
        <MailIcon />
      </ShareLink>
    </>
  );
};
